import { useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { useTitle } from 'react-use';

import Loading from '@/components/atoms/Loading/Loading';
import { LOGIN_ROUTE } from '@/util/constants';

/**
 * Login page that shows a loading spinner and redirects to WorkOS login
 * This prevents re-rendering when transitioning from RequireAuth
 */
const Login = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');
  useTitle(t('auth.login_title'));

  useEffect(() => {
    const loginUrl = returnTo
      ? `${LOGIN_ROUTE}?returnTo=${encodeURIComponent(returnTo)}`
      : LOGIN_ROUTE;
    const timeout = window.setTimeout(() => {
      window.location.href = loginUrl;
    }, 300);
    return () => window.clearTimeout(timeout);
  }, [returnTo]);

  return <Loading label={t('auth.redirecting_to_login')} />;
};

export default Login;
